import { useStore } from "../store";
// import { _postData } from "./apiClient";
import { v4 as uuidv4 } from 'uuid';
const { VITE_PRIVACY_OPT_OUT_URL, VITE_SMB_API_ROUTING_KEY } = window.__conf__;

const optOutUrl = VITE_PRIVACY_OPT_OUT_URL || "#";
const routingKey = VITE_SMB_API_ROUTING_KEY || "";

export const sendPrivacyOptOut = async (): Promise<any> => {
  try {
    const { emailValue } = useStore.getState();
    const resp = await fetch(optOutUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "routingkey": routingKey,
        "correlation-id": uuidv4()
      },
      body: JSON.stringify({"email" : emailValue}),
    });
    if (resp?.ok) {
      const text = await resp.text(); // Read the response as text
      return text ? JSON.parse(text) : {}; // Parse only if text is not empty
    }
    throw new Error(resp?.statusText);
  } catch (err: any) {
    throw new Error(err?.message || err);
  }
};

